module.exports = __webpack_public_path__ + "img/note_dark_icon.2feadea2.svg";